import React, { useState } from 'react'
import ColorPickerV2 from 'src/components/common/ColorPickerV2'
import { InputSlider } from 'src/components/common/slider/InputSlider'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@shopflo/ui'
import { useCheckoutUI } from 'src/lib/contexts/CheckoutUIContext'
import { useCartContext } from 'src/lib/contexts/CartContext'

type BorderSides = 'all' | 'top' | 'bottom' | 'left' | 'right'

interface AddOnConfigType {
  backgroundColor: string
  textColor: string
  buttonColor: string
  cardRadius: number
  cardBorderWidth: number
  cardBorderSides: BorderSides
}

export const AddOnControl = () => {
  const {
    getters: { cartUIData },
    actions: { setCartUIConfigData }
  } = useCartContext()

  const {
    getters: { checkoutUI }
  } = useCheckoutUI()

  const handleConfigChange = (updates: Partial<AddOnConfigType>) => {
    setCartUIConfigData({ ...cartUIData.addonConfig, ...updates }, 'ADDON_CONFIG')
  }

  return (
    <div className='flex flex-col gap-5'>
      {/* Color Pickers */}
      <div className='flex flex-col gap-3'>
        <div className='grid grid-cols-2 gap-2'>
          <ColorPickerV2
            label='Background'
            color={cartUIData.addonConfig.backgroundColor}
            onChange={color => handleConfigChange({ backgroundColor: color })}
          />
          <ColorPickerV2
            label='Text'
            color={cartUIData.addonConfig.textColor}
            onChange={color => handleConfigChange({ textColor: color })}
          />
        </div>
        <div className='grid grid-cols-2 gap-2'>
          <ColorPickerV2
            label='Button'
            color={cartUIData.addonConfig.buttonColor ?? checkoutUI?.colorPalette?.primaryColor ?? '#000000'}
            onChange={color => handleConfigChange({ buttonColor: color })}
          />
        </div>
      </div>
    </div>
  )
}
